import { Button } from '@/components/form/baseInputs/Button';
import { ButtonProps } from '@/components/form/baseInputs/Button/Button';
import { CoinsSwap02Icon } from '@/components/icons/CoinsSwap02Icon';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';

export function UpdateHoldingsButton({ disabled, ...props }: ButtonProps) {
  const canEditHouseholdData = useCanEditHouseholdData();
  return (
    <Button
      {...props}
      startIcon={CoinsSwap02Icon}
      disabled={disabled || !canEditHouseholdData}
    >
      {props.children || 'Update valuation'}
    </Button>
  );
}
